import { BrowserRouter } from 'react-router-dom';

import Dialog from '@components/Modal/Modal';
import ToastList from '@components/Toast/ToastList';
import { Box } from '@mui/material';
import makeStyles from '@mui/styles/makeStyles';
import Constants from 'constants/constants';
import { Body } from 'regions';
import OverrideTheme from 'themes/custom-theme-helper';

/**
 * Gestion du routing
 * Inclusion des régions
 */
export const Main = (): JSX.Element => {
  const useStyles = makeStyles(() => ({
    layout: {
      minHeight: '100vh',
      display: 'flex',
      flexDirection: 'column',
      backgroundColor: OverrideTheme.colors.background,
    },
  }));

  const classes = useStyles();

  return (
    <Box className={classes.layout}>
      <BrowserRouter basename={Constants.Routes.HOME_PATH}>
        <Body />
        <Dialog />
        <ToastList />
      </BrowserRouter>
    </Box>
  );
};
